import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-audit-resources';

@Injectable({
    providedIn: 'root'
})
export class AuditService {

    constructor(private fabricService: FabricService) {
    }

    getAuditLog(auditObj?): Observable<any> {
        return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_audit-logs', auditObj)
    }

    getAuditlogId(id?): Observable<any> {
        return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_audit-logs_id', { id })
    }

}